// theme.js

const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

// The palette: deep green on warm cream, like a workplace drawn in daylight (the Game Builder's scenes are warm too).
export const colors = {
  primary: "#1f6b4f",
  primaryDark: "#174f3b",
  primarySoft: "#e7f1ec",
  accent: "#2f8a5f",

  textDark: "#0f1f1a",
  text: "#3c4a44",
  textMuted: "#6b7670",

  border: "#e7e1d6",
  bgSoft: "#faf7f2",
  cream: "#f4eee4",
  white: "#ffffff",

  danger: "#c0392b",
};

export const fonts = {
  body: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
};

export const typography = {
  h1: {
    fontSize: isMobile ? "2.1rem" : "3.25rem",
    fontWeight: 800,
    lineHeight: 1.08,
    letterSpacing: "-0.03em",
  },
  h2: {
    fontSize: isMobile ? "1.5rem" : "2rem",
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h3: {
    fontSize: isMobile ? "1.1rem" : "1.25rem",
    fontWeight: 600,
  },
  body: {
    fontSize: "1rem",
    lineHeight: 1.55,
  },
  small: {
    fontSize: "0.85rem",
  },
  eyebrow: {
    fontSize: "0.78rem",
    fontWeight: 700,
    letterSpacing: "0.22em",
    textTransform: "uppercase",
  },
};


// theme.js
export const breakpoints = {
  mobile: 640,
  tablet: 768,
  desktop: 1024,
};


export const spacing = {
  sectionY: isMobile ? "48px" : "96px",
  sectionX: isMobile ? "16px" : "32px",

  cardPadding: isMobile ? 16 : 24,
  gapSm: 8,
  gapMd: 16,
  gapLg: isMobile ? 24 : 40,
};

export const radius = {
  sm: 8,
  md: 12,
  lg: isMobile ? 12 : 16,
};

export const shadows = {
  soft: "0 8px 24px rgba(0,0,0,0.08)",
  strong: "0 24px 48px rgba(0,0,0,0.12)",
};

export const container = {
  maxWidth: isMobile ? "100%" : "1200px",
  padding: isMobile ? "0 16px" : "0 32px",
};
